
export default {
name: 'drawMoney',
components: {

},
data () {
return {

}
},
methods: {

},
created () {

},
mounted() {

}
}



// WEBPACK FOOTER //
// ./src/views/drawMoney/script.js